import { usePremiumIntent, useStandardIntent } from '@/components/user-context/helpers/cohorts';

import { LoggedInConfluenceFree } from './free/logged-in-confluence-free';
import { LoggedInConfluencePremium } from './premium/logged-in-confluence-premium';
import { LoggedInConfluenceStandard } from './standard/logged-in-confluence-standard';

export const LoggedInConfluence = () => {
	const isStandard = useStandardIntent();
	const isPremium = usePremiumIntent();

	if (isStandard) {
		return <LoggedInConfluenceStandard />;
	}

	if (isPremium) {
		return <LoggedInConfluencePremium />;
	}

	return <LoggedInConfluenceFree />;
};
